import { render } from "./postCommentItem.vue?vue&type=template&id=7be4e72a&scoped=true"
import script from "./postCommentItem.vue?vue&type=script&lang=js"
export * from "./postCommentItem.vue?vue&type=script&lang=js"

import "./postCommentItem.vue?vue&type=style&index=0&id=7be4e72a&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be4e72a"]])

export default __exports__